import commonConfig from './common';
import actionsConfig from '../actions/_config';
import appConfig from '../app/_config';
import contextConfig from '../context/_config';
import searchConfig from '../search/_config';
import sectionsConfig from '../sections/_config';
import accordionTagConfig from '../accordion-tag/_config';


const config = (di) => {
	commonConfig(di);

	actionsConfig(di);
	appConfig(di);
	contextConfig(di);
	searchConfig(di);
	sectionsConfig(di);
	accordionTagConfig(di);

	const bodyData = di.get('dom/dataAttrFactory')({element: document.body});
	const baseUrl = bodyData.get('baseUrl', '');

	di
		.setValue('baseUrl', baseUrl)
		.setValue('search/searchUrl', bodyData.get('searchUrl', ''))
		.setParam('PageLoader', 'baseUrl', baseUrl)
		// .setParam('HashScroller', 'duration', 0.5)
		// .setParam('Navigation', 'navigateSameUrl', true)
	;
};


export default config;
